<template>
	<section class="rooms-promotions background-light main-content align-center">
		<SectionHeader :subtitle="subtitle" :title="title" :content="content" />
		<PromoOverview>
			<PromoCard v-for="room in items.slice(0, 4)" :key="room.ID" :item="room" variant="room" />
		</PromoOverview>
		<nuxt-link v-if="buttonLabel" class="button" :to="localePath('rooms')">
			{{ buttonLabel }}
		</nuxt-link>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	subtitle: { type: String, default: '' },
	title: { type: String, default: '' },
	content: { type: String, default: '' },
	buttonLabel: { type: String, default: '' },
});
</script>

<style scoped lang="scss">
.row-header {
	max-width: 980px;
}
</style>
